import { logoutUser } from '../actions/userActions';

export const logoutOnInvalidToken = (e: { statusCode: number } | undefined) => {
  if (e?.statusCode === 401) {
    logoutUser();
  }
};
